const TOKEN_KEY = "adminToken";
const USER_KEY = "adminUser";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function getAdmin() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch (err) {
    return null;
  }
}

export function saveSession(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(admin));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
